import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { Select } from 'primeng/select';
import { DatePicker } from 'primeng/datepicker';
import { Constants, LocaleService } from '../../_utility';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../_components/breadcrumbs/breadcrumbs.service';
import { SpinnerService } from '../../_components/spinner/spinner.service';
import { ApiService } from '../../_services';
import { Restaurant } from '../../_models/Restaurant';
import { ReservationResponse } from '../../_models/Reservation';
import * as XLSX from 'xlsx';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-extraction',
  templateUrl: './extraction.component.html',
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [TableModule, ButtonModule, Select, DatePicker, ReactiveFormsModule, TranslateModule],
})
export class ExtractionComponent implements OnInit {
  form: FormGroup;
  selectedRestaurant!: Restaurant;
  restaurants: Restaurant[] = [];
  bookings: ReservationResponse[] = [];
  date: Date | undefined;
  loaded = false;
  public retentionDate: Date = new Date(
    new Date().setDate(new Date().getDate() - Constants.RETENTION_WINDOW)
  );
  constructor(
    private router: Router,
    private breadcrumb: BreadcrumbsService,
    private spinner: SpinnerService,
    private apiService: ApiService,
    private fb: FormBuilder,
    private locale: LocaleService
  ) {
    this.form = this.fb.group({
      selectedRestaurant: ['', [Validators.required]],
      startDate: [''],
      endDate: [''],
    });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.breadcrumb.setCrumbs(Constants.Routing.EXTRACTION.path);
    }, 200);
    this.spinner.show();
    this.apiService.Restaurants().subscribe({
      next: (data) => {
        this.restaurants = data;
        this.spinner.hide();
      },
      error: (error) => {
        console.error(error);
        this.spinner.hide();
      },
    });
  }

  Search() {
    this.spinner.show();
    this.apiService
      .Reservations(
        this.form.value.selectedRestaurant.uuid_restaurant,
        DateTime.fromJSDate(this.form.value.startDate).toSQLDate()!,
        DateTime.fromJSDate(this.form.value.endDate).toSQLDate()!
      )
      .subscribe({
        next: (data) => {
          this.bookings = data;
          this.loaded = true;
          this.spinner.hide();
        },
        error: (error) => {
          console.error(error);
          this.spinner.hide();
        },
      });
  }
  DownloadReport() {
    this.spinner.show();
    this.apiService
      .Reservations(
        this.form.value.selectedRestaurant.uuid_restaurant,
        DateTime.fromJSDate(this.form.value.startDate).toSQLDate()!,
        DateTime.fromJSDate(this.form.value.endDate).toSQLDate()!,
        true
      )
      .subscribe({
        next: (data) => {
          const myworksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([]);
          XLSX.utils.sheet_add_aoa(
            myworksheet,
            Constants.XLSX.xlsxColumns_event[this.locale.getLanguage()]
          );

          const sortedHeader = [
            'id_reservation',
            'reservation_date',
            'slot_start_datetime',
            'id_cabin',
            'passenger_name',
            'age',
            'costa_club_level',
            'badge_number',
            'attendees',
            'table_name',
            'myitalian',
            'notes',
          ];
          XLSX.utils.sheet_add_json(myworksheet, data, {
            origin: 'A2',
            header: sortedHeader,
            skipHeader: true,
          });

          const myworkbook: XLSX.WorkBook = {
            Sheets: { Report: myworksheet },
            SheetNames: ['Report'],
          };

          XLSX.writeFile(
            myworkbook,
            'WRT_Costa_Prenotazioni_' +
              this.form.value.selectedRestaurant.name +
              '.xlsx'
          );
          this.spinner.hide();
        },
        error: (error) => {
          console.error(error);
          this.spinner.hide();
        },
      });
  }

  Back() {
    this.goTo('booking_management');
  }

  goTo(path: string) {
    switch (path) {
      case 'home': {
        this.router.navigate(Constants.Routing.HOME.routerLink);
        break;
      }
      case 'booking_management': {
        this.router.navigate(Constants.Routing.HOME_PRENOTAZIONI.routerLink);
        break;
      }
    }
  }
}
